import { AxiosError, AxiosInstance } from 'axios';
import { PaymentDto } from 'service/dto/payment.dto';
import { errorHandler } from 'utils';

class PaymentService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  initializePayment = async (paymentDto: PaymentDto) => {
    try {
      const response = await this.baseService.post(
        '/payment/initialize',
        paymentDto
      );
      return response?.data.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  verifyPayment = async (reference: string) => {
    try {
      const response = await this.baseService.get(
        `/payment/verify/${reference}`
      );
      return response.data.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getAllPlans = async () => {
    try {
      const response = await this.baseService.get(`/pricing`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getAPlan = async (planId: number) => {
    try {
      const response = await this.baseService.get(`/pricing/${planId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default PaymentService;
